import ImgServicio from '../../../media/felsv/dark_reader_icon.svg'
import ImgProducto from '../../../media/felsv/dark_box_icon.svg'

export default function SwitchTipoProductoDTE (props: any){
    return (
        <div className='label-input'>
        <label htmlFor='tipo' className='field-label m'>Tipo de producto</label>
        <div className='div-block'>
          <button type='button' className={`product-type w-inline-block div-button ${ props.producto ? 'product-type-active' : ''}`} onClick={props.setProducto} disabled={props.disabled}>
            <img src={ImgProducto} loading='lazy' alt='Producto' />
            <div>Producto</div>
          </button>
          <button type='button' className={`product-type w-inline-block div-button ${ !props.producto ? 'product-type-active' : ''}`} onClick={props.setServicio} disabled={props.disabled}>
            <img src={ImgServicio} loading='lazy' alt='Servicio' />
            <div>Servicio</div>
          </button>
        </div>
      </div>
    )
}